import React, { ReactElement, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IRootState } from "../redux/store";
import { AllRouteConstants } from "../router/routes";

export interface RequireAuthProps {
  children: ReactElement;
}

export const RequireAuth: React.FC<RequireAuthProps> = ({ children }) => {
  const user = useSelector((state: IRootState) => state.user);

  const navigate = useNavigate();

  useEffect(() => {
    if (!user.data) {
      navigate(AllRouteConstants.auth.login);
    }
  }, [user]);

  return children;
};
